import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotComicsSection from './components/HotComicsSection';
import LatestUpdatesSection from './components/LatestUpdatesSection';
import PopularRankingSection from './components/PopularRankingSection';
import NewsletterSection from './components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫 - 韩国漫画大全',
  url: 'https://hanman.com',
  description: '韩漫网站，免费阅读并观看下拉式漫画，利用漫画网址浏览好看韩国漫画大全，精选高质量作品且阅读流畅，满足您所有漫画需求并提升娱乐体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hanman.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫',
  url: 'https://hanman.com',
  description: '韩漫网站 - 免费阅读韩国漫画的在线平台',
  sameAs: [],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-400-888-9999',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫网站_免费阅读看漫画下拉式_漫画韩漫网址_好看的韩国漫画大全"
        description="韩漫网站，免费阅读并观看下拉式漫画，利用漫画网址浏览好看韩国漫画大全，精选高质量作品且阅读流畅，满足您所有漫画需求并提升娱乐体验。热门推荐我独自升级、某天成为公主、全知读者视角等精彩韩漫。"
        keywords="韩漫网站, 免费阅读看漫画, 下拉式, 漫画韩漫网址, 好看的韩国漫画大全, 韩国漫画在线阅读"
        canonicalPath="/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20webtoon%20website%20homepage%20banner%20illustration%20with%20colorful%20comic%20panels%20floating%2C%20warm%20inviting%20colors%2C%20manga%20reading%20aesthetic%2C%20clean%20composition&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={{ ...homeSchema, ...orgSchema }}
      />

      <main>
        <HeroBanner />
        <CategorySection />
        <HotComicsSection />
        <LatestUpdatesSection />
        <PopularRankingSection />
        <NewsletterSection />
      </main>
    </>
  );
}